import {gql} from "@apollo/client";

export const ADMIN_UPDATESHUFFLELEADERBOARD = gql`
    mutation updateShuffleLeaderboard($position: Int!, $name: String!, $wagered: Float!){
        updateShuffleLeaderboard(position: $position, name: $name, wagered: $wagered){ Updated }
    }
`;

export const ADMIN_RESETSHUFFLELEADERBOARD = gql`
    mutation resetShuffleMonth{
        resetShuffleMonth{ Updated }
    }
`;
